import { motion } from "framer-motion";
import { Clock, Mail, MapPin, Phone, Smartphone } from "lucide-react";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="mx-auto max-w-7xl scroll-mt-28 px-4 py-20 sm:px-6 lg:px-12">
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="mb-10 text-center"
    >
      <span className="text-xs tracking-widest text-amber-500/70">در خدمت شما هستیم</span>
      <h2 className="mt-2 text-base font-bold text-amber-100 md:text-lg">تماس و آدرس فروشگاه</h2>
    </motion.div>
    <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
      <motion.div
        data-testid="store-address"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7 }}
        className="glass gold-sheen rounded-2xl p-7 text-center"
      >
        <MapPin className="mx-auto mb-4 h-6 w-6 text-amber-400" />
        <h3 className="mb-3 text-sm font-bold text-amber-200">آدرس فروشگاه</h3>
        <p className="text-sm font-light leading-7 text-stone-400">
          تهران، خیابان ولیعصر، بین تقاطع فاطمی و یوسف‌آباد، پلاک ۱۹۶۴
        </p>
      </motion.div>
      <motion.div
        data-testid="store-phone"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay: 0.12 }}
        className="glass gold-sheen rounded-2xl p-7 text-center"
      >
        <Phone className="mx-auto mb-4 h-6 w-6 text-amber-400" />
        <h3 className="mb-3 text-sm font-bold text-amber-200">تماس</h3>
        <div className="space-y-2 text-sm">
          <a data-testid="contact-tel" href="tel:+982188977824" className="flex items-center justify-center gap-2 text-stone-300 transition-colors hover:text-amber-300">
            <Phone className="h-3.5 w-3.5 text-amber-500/70" />
            <span dir="ltr">+98 21 88977824</span>
          </a>
          <a data-testid="contact-mobile" href="tel:+989122682823" className="flex items-center justify-center gap-2 text-stone-300 transition-colors hover:text-amber-300">
            <Smartphone className="h-3.5 w-3.5 text-amber-500/70" />
            <span dir="ltr">+98 912 2682823</span>
          </a>
          <a data-testid="contact-email" href="mailto:kazeranicoin@gmail.com" className="flex items-center justify-center gap-2 text-stone-300 transition-colors hover:text-amber-300">
            <Mail className="h-3.5 w-3.5 text-amber-500/70" />
            <span dir="ltr">kazeranicoin@gmail.com</span>
          </a>
        </div>
      </motion.div>
      <motion.div
        data-testid="store-hours"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay: 0.24 }}
        className="glass gold-sheen rounded-2xl p-7 text-center"
      >
        <Clock className="mx-auto mb-4 h-6 w-6 text-amber-400" />
        <h3 className="mb-3 text-sm font-bold text-amber-200">ساعات کاری</h3>
        <p className="text-sm font-light leading-8 text-stone-400">
          شنبه تا چهارشنبه · ۱۰:۰۰ الی ۱۹:۰۰
          <br />
          پنجشنبه · ۱۰:۰۰ الی ۱۸:۰۰
        </p>
      </motion.div>
    </div>
  </section>
);
